import { Component } from '@angular/core';

@Component({
  selector: 'app-afericao-servico',
  templateUrl: './afericao-servico.component.html',
  styleUrls: ['./afericao-servico.component.scss']
})
export class AfericaoServicoComponent {
 selectedTabAfericoesIndex: number = 0;
}
